<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="600">
    <template v-slot:title>{{ editorTitle }}</template>
    <v-row>
      <v-col>
        <v-combobox
          v-model="name"
          :items="knownSettingNames"
          label="Name"
          :outlined="outlinedInputs"
          hide-details
        ></v-combobox>
      </v-col>
      <v-col>
        <third-party-setting-input
          v-model="content"
          :setup-name="setupName"
          :setting-name="name"
          :outlined="outlinedInputs"
        />
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
import ThirdPartySettingInput from "../../shared/third-party-setups/ThirdPartySettingInput.vue";
import { thirdPartySetupTemplate } from "../../../../constants/thirdPartySetups";
const randomize = require("randomatic");
export default {
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => false,
    },
    // name of the setup being edited, for the known setting names and input types
    setupName: {
      type: String,
      default: "",
    },
  },
  name: "third-party-setting-edit-dialog",
  components: { BasicDialog, ThirdPartySettingInput },

  data() {
    return {
      debug: false,
      name: this.value ? this.value.name : "",
      content: this.value ? this.value.content : "",
    };
  },

  computed: {
    isValid() {
      return (this.name || "").trim() != "";
    },
    knownSettingNames() {
      const template = thirdPartySetupTemplate(this.setupName);
      return template ? template.settings.map((s) => s.name) : [];
    },
    editorTitle() {
      return this.value
        ? "Edit Third Party Setting"
        : "Create Third Party Setting";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.name = newVal.name;
        this.content = newVal.content;
      } else {
        this.name = "";
        this.content = "";
      }
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        id: this.value ? this.value.id : randomize("Aa0", 10),
        name: (this.name || "").trim(),
        content: this.content,
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/plugins/third-party-setups/ThirdPartySettingEditDialog.vue